<template>
  <div class="site-logo">
    <router-link :to="{ name: 'profileSelection' }">
      <img
        :src="appLogo"
        tag="img"
        alt="avatar"
        :height="height"
        v-if="appLogo"
        :event="disableredirect ? '': 'click'"
      >
    </router-link>
  </div>
</template>

<script>
import AppConfig from 'Constants/AppConfig';
import { bizgainConfig } from 'Features/bizgainOnboarding/constants';
import { mapGetters } from 'vuex';

export default {
  props: {
    height: {
      type: Number,
      default: 35
    },
    disableredirect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['sidebarSelectedFilter', 'portal', 'isForBizgain'])
  },
  data() {
    return {
      appLogo: null
    };
  },
  created() {
    if(this.isForBizgain){
      this.appLogo = bizgainConfig.bizgainPrimaryLogo;
    } else if (this.portal && this.portal.headerLogo) {
      this.appLogo = AppConfig.logoStoragePath + this.portal.headerLogo;
    } else {
      this.appLogo = AppConfig.appLogo;
    }
  }
};
</script>
